module.exports = __webpack_public_path__ + "static/media/no-meetings-found.edf293e8.svg";